<div class="inner-page-header">
  <h3>الرؤى — إحصائيات اسأل عاين</h3>
</div>

<div class="main-card insights-dashboard">
  <app-ask-ayen-statistics-cards [stats]="stats"></app-ask-ayen-statistics-cards>

  <app-ask-ayen-insights-filters (filtersChange)="onFiltersChange($event)"></app-ask-ayen-insights-filters>

  <div class="dashboard-row">
    <app-ask-ayen-questions-chart class="dash-col-lg" [trend]="monthlyTrend"></app-ask-ayen-questions-chart>
    <app-ask-ayen-user-distribution class="dash-col-sm" [distribution]="specialtyDistribution"></app-ask-ayen-user-distribution>
  </div>

  <div class="dashboard-row">
    <app-ask-ayen-experts class="dash-col-sm" [experts]="topExperts"></app-ask-ayen-experts>
    <app-ask-ayen-recent-activity class="dash-col-lg" [questions]="topQuestions"></app-ask-ayen-recent-activity>
  </div>
</div>
